import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { Badge } from 'DesignSystem/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'DesignSystem/ui/tooltip';

type Props = {
  row: Row<UpstreamEvent>;
};

export function EventTypes({ row }: Props) {
  const types = row.original.types;

  if (!types || types.length === 0) return <>–</>;

  if (types.length > 1) {
    return (
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <Badge variant="informative" className="cursor-default text-nowrap hover:bg-blue-300">
              {types[0]} + {types.length - 1}
            </Badge>
          </TooltipTrigger>
          <TooltipContent className="flex max-w-[300px] flex-col gap-1 text-wrap p-2">
            {types.join(', ')}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Badge variant="informative" className="text-nowrap">
      {types[0]}
    </Badge>
  );
}
